export default __webpack_public_path__ + "static/media/mascote-corpo.affc6a3a.webp";